import { SourceDataFindingStatus, SourceDataFindingType } from "@/api/dtos";
import { ChipProps } from "@mui/material";

const mapping: Record<SourceDataFindingStatus, ChipProps['color']> = {
    [SourceDataFindingStatus.Resolved]: 'success',
    [SourceDataFindingStatus.Pending]: 'error',
    [SourceDataFindingStatus.NotApplicable]: 'default'
};

const sourceDataFindingStatusToColor = (status?: SourceDataFindingStatus) => {
    if (!status) {
        return 'default'
    }

    return mapping[status];
}

export default sourceDataFindingStatusToColor;